import { formatDistanceToNow } from "date-fns";
import { Briefcase, Mail, MapPin, UserRound } from "lucide-react";

export function DuplicateCard({ dup, reasons = [], testId = "duplicate-card", children }) {
  if (!dup) return null;
  return (
    <div className="space-y-3 rounded-[6px] border border-[#E8D7B0] bg-caution-tint/60 p-4" data-testid={testId}>
      <p className="text-sm font-medium text-caution">This looks like a candidate you already have{reasons.length ? ` (${reasons.join(", ").toLowerCase()})` : ""}.</p>
      <div className="flex items-start gap-3 rounded-[6px] bg-white p-3 ring-1 ring-line">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-tint text-brand"><UserRound size={16} aria-hidden="true" /></span>
        <div className="min-w-0 space-y-1 text-sm">
          <p className="font-semibold text-ink" data-testid={`${testId}-name`}>{dup.name}</p>
          <p className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-ink-secondary">
            {dup.email_masked && <span className="inline-flex items-center gap-1"><Mail size={12} aria-hidden="true" />{dup.email_masked}</span>}
            {dup.location && <span className="inline-flex items-center gap-1"><MapPin size={12} aria-hidden="true" />{dup.location}</span>}
            {dup.current_title && <span className="inline-flex items-center gap-1"><Briefcase size={12} aria-hidden="true" />{dup.current_title}</span>}
          </p>
          <p className="text-xs text-ink-muted">{dup.jobs?.length ? `Applied to ${dup.jobs.join(", ")}` : "Talent pool (no job)"}{dup.created_at && ` · added ${formatDistanceToNow(new Date(dup.created_at), { addSuffix: true })}`}</p>
        </div>
      </div>
      {children && <div className="flex flex-wrap gap-2">{children}</div>}
    </div>
  );
}
